'use strict';
import * as $j_app$002epages$002e$002dDocuments$002dCreate$002dPage$0024$002dBased$002dOn from "./app.pages.-Documents-Create-Page$-Based-On.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_pages_DocumentsCreatePage$BasedOn$Template(templateId) {
  this.Md = null;
  this.Md = templateId;
}
export { $c_Lapp_pages_DocumentsCreatePage$BasedOn$Template as $c_Lapp_pages_DocumentsCreatePage$BasedOn$Template };
$p = $c_Lapp_pages_DocumentsCreatePage$BasedOn$Template.prototype = new $j_app$002epages$002e$002dDocuments$002dCreate$002dPage$0024$002dBased$002dOn.$h_Lapp_pages_DocumentsCreatePage$BasedOn();
$p.constructor = $c_Lapp_pages_DocumentsCreatePage$BasedOn$Template;
/** @constructor */
function $h_Lapp_pages_DocumentsCreatePage$BasedOn$Template() {
}
export { $h_Lapp_pages_DocumentsCreatePage$BasedOn$Template as $h_Lapp_pages_DocumentsCreatePage$BasedOn$Template };
$h_Lapp_pages_DocumentsCreatePage$BasedOn$Template.prototype = $p;
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, (-889275714), false);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_pages_DocumentsCreatePage$BasedOn$Template)) {
    var x = this.Md;
    var x$2 = x$0.Md;
    return ((x === null) ? (x$2 === null) : x.f(x$2));
  } else {
    return false;
  }
});
$p.n = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().V(this);
});
$p.s = (function() {
  return 1;
});
$p.t = (function() {
  return "Template";
});
$p.e = (function(n) {
  if ((n === 0)) {
    return this.Md;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.u = (function(n) {
  if ((n === 0)) {
    return "templateId";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.co = (function() {
  return 2;
});
function $isArrayOf_Lapp_pages_DocumentsCreatePage$BasedOn$Template(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.ko)));
}
export { $isArrayOf_Lapp_pages_DocumentsCreatePage$BasedOn$Template as $isArrayOf_Lapp_pages_DocumentsCreatePage$BasedOn$Template };
var $d_Lapp_pages_DocumentsCreatePage$BasedOn$Template = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_pages_DocumentsCreatePage$BasedOn$Template, "app.pages.DocumentsCreatePage$BasedOn$Template", ({
  ko: 1,
  fT: 1,
  b: 1,
  c: 1,
  a: 1,
  l: 1
}));
export { $d_Lapp_pages_DocumentsCreatePage$BasedOn$Template as $d_Lapp_pages_DocumentsCreatePage$BasedOn$Template };
//# sourceMappingURL=app.pages.-Documents-Create-Page$-Based-On$-Template.js.map
